import { Col, Row } from "react-grid-system";
import { Button } from "../atoms";
import styled from "styled-components";

type ConfirmationDialogProps = {
  cancelButton?: {
    action: () => void,
    text: string
  },
  confirmButton: {
    action: () => void
    text: string
  }
  description: string
  title?: string
}

const Wrapper = styled.div`
  margin: 0 auto;
  padding: 20px;
  min-width: 80%;
  max-width: 700px;
`

const TextContainer = styled(Row)`
  padding-bottom: 4rem;
  & h1 {
    font-size: ${({ theme }) => theme.typography.fontSize.s4};
  }
`

const StyledButton = styled(Button)`
  font-weight: 300;
`

/**
 * Props for the ConfirmationDialog component.
 * 
 * @property [cancelButton] - Optional cancel button configuration.
 * @property cancelButton.action - Function to execute on cancel button click.
 * @property cancelButton.text - Text to display on the cancel button.
 * @property confirmButton - Confirm button configuration.
 * @property confirmButton.action - Function to execute on confirm button click.
 * @property confirmButton.text - Text to display on the confirm button.
 * @property description - Description text to display in the dialog.
 * @property [title] - Optional title text to display in the dialog.
 */

/**
 * A confirmation dialog component that displays a title, description, and confirm/cancel buttons.
 * 
 * @component
 * @param props - The props for the component.
 * @returns The rendered confirmation dialog component.
 */
export const ConfirmationDialog = ({ title, description, confirmButton, cancelButton}: ConfirmationDialogProps) => {
  return (
    <Wrapper>
      <TextContainer>
        {
          title
          ? (
              <Col xs={12}>
                <h1>
                  {title}
                </h1>
              </Col>
            )
          : null
        }
        <Col xs={12}>
          <p>
            {description}
          </p>
        </Col>
      </TextContainer>
      <Row justify="center">
          {
            cancelButton
            ? (
              <Col>
                <StyledButton
                  onClick={cancelButton.action}
                  secondary
                >
                  {cancelButton.text}
                </StyledButton>
              </Col>
            )
            : null
          }
        <Col>
          <StyledButton
            onClick={confirmButton.action}
            submit
          >
            {confirmButton.text}
          </StyledButton>
        </Col>
      </Row>
    </Wrapper>
  )
}
